import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) {
      return '';
    }

    // Remove any non-digit characters from the input string
    const phoneNumber = value.replace(/^\+1/, '').replace(/\D/g, '');

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 11)}`;
  }
}
